import { useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { getFormatDataByDate } from '@portal-internet/core';
import { useViewport } from 'hooks/corporatiu/useViewport';
import { useEmitter } from 'hooks/useEmitter';
import Dropdown from 'components/corporatiu/Dropdown';
import Boto from 'components/corporatiu/Boto';
import Icona from 'components/corporatiu/ui/Icona';
import { split } from 'lodash';
import __isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import styles from './cercadorfiltres.module.scss';

const _getInitUrlCerca = (props) => {
    const { urlCerca, filtresProfile, routerQuery } = props;
    if (!__isEmpty(urlCerca)) return urlCerca;
    if (__isEmpty(filtresProfile)) return '';
    const profileSelect = routerQuery.profile
        ? filtresProfile.find((item) => item.profile === routerQuery.profile)
        : filtresProfile[0];
    return profileSelect.urlCerca;
};

const _getUrlCerca = (urlCerca, searchParams) => {
    if (!__isEmpty(searchParams.textDate)) {
        urlCerca = urlCerca.replace('{{TEXT_DATA_INICI}}-{{TEXT_DATA_FI}}', searchParams.textDate);
    } else if (__isEmpty(searchParams.fromDate) && __isEmpty(searchParams.toDate)) {
        urlCerca = urlCerca.replace('{{TEXT_DATA_INICI}}-{{TEXT_DATA_FI}}', 'SEMPRE');
    } else if (__isEmpty(searchParams.fromDate)) {
        urlCerca = urlCerca.replace('{{TEXT_DATA_INICI}}', getFormatDataByDate(new Date('1983-09-10')));
    } else if (__isEmpty(searchParams.toDate)) {
        urlCerca = urlCerca.replace('{{TEXT_DATA_FI}}', getFormatDataByDate(new Date()));
    }

    return urlCerca
        .replace('{{TEXT_CERCA}}', encodeURIComponent(searchParams.searchValue))
        .replace('{{TEXT_DATA_INICI}}', getFormatDataByDate(searchParams.fromDate))
        .replace('{{TEXT_DATA_FI}}', getFormatDataByDate(searchParams.toDate));
};

const _getHistoryState = (props) => {
    const { router, sendParams } = props;
    const { searchValue, fromDate, toDate, searchProfile, textDate } = sendParams;
    const LocationString = (path) => {
        return {
            value: path,
            addParam(key, paramValue) {
                const separator = this.value.includes('?') ? '&' : '?';
                this.value = `${this.value}${separator}${key}=${paramValue}`;
                return this;
            },
            toString() {
                return this.value;
            }
        };
    };

    const location = LocationString(router.basePath).addParam('text', encodeURIComponent(searchValue));
    if (searchProfile) location.addParam('profile', searchProfile);
    location.addParam('data_publicacio', textDate || fromDate + '-' + toDate);

    return location.toString();
};

const FiltresProfile = (props) => {
    const { filtres, actiu, onChange } = props;
    const [filterSelect, setFilterSelect] = useState(actiu || filtres?.[0]?.profile);

    if (__isEmpty(filtres)) return <></>;

    const handleOnClick = (item) => {
        setFilterSelect(item.profile);
        onChange(item);
    };

    return (
        <ul className={styles.llistatFiltres}>
            {filtres.map((item) => {
                const styleBoto = clsx({
                    [styles.botoFiltresProfile]: true,
                    [styles.seleccionat]: filterSelect === item.profile
                });
                return (
                    <li className={styles.filtre} key={`cercador-filtres-filtre-${item.profile}`}>
                        <Boto
                            tag='button'
                            estil='noEstil'
                            className={styleBoto}
                            onClick={() => handleOnClick(item)}
                            text={item.nom}
                            dataTestId={`cercador-llistatfiltres-${item.profile}`}
                        />
                    </li>
                );
            })}
        </ul>
    );
};

const FiltresPerData = (props) => {
    const { mostrarFiltrarPerData, onChange } = props;
    if (!mostrarFiltrarPerData) return <></>;

    const filtres = [
        {
            id: 'SEMPRE',
            titol: 'Sempre'
        },
        {
            id: 'ULTIMASETMANA',
            titol: 'Última setmana'
        },
        {
            id: 'ULTIMMES',
            titol: 'Últim mes'
        },
        {
            id: 'ULTIMANY',
            titol: 'Últim any'
        }
    ];

    return (
        <div className={styles.selectFiltresPerData}>
            <Dropdown
                updateDropdown={(item) => onChange(item.id)}
                items={filtres}
                textSelector='Filtra per data'
                className={styles.dropdownFiltresData}
            />
        </div>
    );
};

const CercadorFiltres = (props) => {
    const {
        idActivador,
        placeholder,
        portal,
        className,
        estil,
        cercaPerQueryParam,
        titol,
        disposicio,
        filtresProfile,
        tag = 'div',
        mostrarCercadorLliure = true,
        mostrarDesDe = true,
        mostrarFinsA = true,
        newPage = false,
        mostrarFiltrarPerData = false
    } = props;

    const TagSeo = tag;
    const { isOnlyMobile } = useViewport();
    const { emit } = useEmitter();
    const fromDateRef = useRef(null);
    const endDateRef = useRef(null);
    const [open, setOpen] = useState(false);

    const toggleAccordion = () => {
        setOpen(!open);
    };

    const router = useRouter();
    const searchValueDate =
        props.routerQuery.data_publicacio == 'SEMPRE' ? '' : split(props.routerQuery.data_publicacio || '', '-');

    const searchParams = useRef({
        urlCerca: _getInitUrlCerca(props),
        searchValue: cercaPerQueryParam || '',
        searchValueFrom: searchValueDate[0] || '',
        searchValueTo: searchValueDate[1] || '',
        textDate:
            props.routerQuery.data_publicacio == 'SEMPRE' || props.routerQuery.data_publicacio?.includes('-')
                ? ''
                : props.routerQuery.data_publicacio || '',
        searchProfile: __isEmpty(filtresProfile) ? false : props.routerQuery.profile || filtresProfile[0].profile
    });

    const [searchValue, setSearchValue] = useState(cercaPerQueryParam || '');
    const [searchValueFrom, setSearchValueFrom] = useState(searchValueDate[0] || '');
    const [searchValueTo, setSearchValueTo] = useState(searchValueDate[1] || '');

    const styleInput = clsx({
        [styles.cercadorFiltres]: true,
        [styles[portal]]: !__isEmpty(portal),
        [styles[estil]]: !__isEmpty(estil),
        [className]: !__isEmpty(className),
        [styles.isMobile]: isOnlyMobile,
        [styles.obert]: open,
        [styles.vertical]: disposicio === 'vertical'
    });

    const formatDate = (dateString) => {
        if (__isEmpty(dateString)) return dateString;
        if (dateString.includes('-')) return dateString;
        const [day, month, year] = dateString.split('/');
        return `${year}-${month}-${day}`;
    };

    const onChangeCercadorValue = ({ target }) => {
        const { name, value } = target;
        switch (name) {
            case 'fromDate':
                searchParams.current.searchValueFrom = value;
                setSearchValueFrom(value);
                break;
            case 'toDate':
                searchParams.current.searchValueTo = value;
                setSearchValueTo(value);
                break;
            case 'cercador':
            default:
                searchParams.current.searchValue = value;
                setSearchValue(value);
                break;
        }
    };

    const submitSearch = () => {
        const { urlCerca, searchValueFrom, searchValueTo, textDate, searchProfile } = searchParams.current;
        const url = _getUrlCerca(urlCerca, {
            searchValue,
            fromDate: searchValueFrom,
            toDate: searchValueTo,
            textDate
        });

        if (newPage) {
            router.push('/' + url);
        } else {
            const dateFrom = __isEmpty(searchValueFrom)
                ? getFormatDataByDate(new Date('1983-09-10'))
                : getFormatDataByDate(searchValueFrom);
            const dateTo = __isEmpty(searchValueTo) ? getFormatDataByDate(new Date()) : getFormatDataByDate(searchValueTo);
            const sendParams = {
                url,
                searchValue,
                fromDate: dateFrom,
                toDate: dateTo,
                textDate,
                searchProfile
            };
            emit(idActivador, sendParams);
            window.history.replaceState({}, '', _getHistoryState({ router, sendParams, filtresProfile }));
        }
    };

    const updateAndSubmit = (key, value) => {
        searchParams.current[key] = value;
        submitSearch();
    };

    const handleIconClick = (inputRef) => {
        if (inputRef.current && typeof inputRef.current.showPicker === 'function') {
            inputRef.current.showPicker();
        }
    };

    const handleIconKeyDown = (e, inputRef) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleIconClick(inputRef);
        }
    };

    return (
        <TagSeo>
            <form
                role='search'
                onSubmit={(e) => {
                    e.preventDefault();
                }}
                className={styleInput}
            >
                {titol && isOnlyMobile && disposicio === 'vertical' && (
                    <button className={styles.header} aria-expanded={open} onClick={toggleAccordion}>
                        <div className={styles.titol}>{titol}</div>
                        <Icona className={styles.icona} icona='fletxa_simple_avall' alt='fletxa desplegar' isBlanc={false} />
                    </button>
                )}

                {titol && !isOnlyMobile && disposicio === 'vertical' && (
                    <div className={styles.header}>
                        <div className={styles.titol}>{titol}</div>
                    </div>
                )}

                <div className={styles.contentSearch}>
                    {mostrarCercadorLliure && (
                        <div className={styles.columnaCerca}>
                            <label className={styles.label} htmlFor='cercador-inputCerca'>
                                Cercador
                            </label>
                            <input
                                id='cercador-inputCerca'
                                data-testid='cercador-textLliure'
                                name='cercador'
                                type='search'
                                placeholder={placeholder}
                                value={searchValue}
                                aria-label='Cercador'
                                className={styles.inputCercador}
                                onChange={onChangeCercadorValue}
                                onKeyDown={({ key }) => {
                                    if (key === 'Enter') submitSearch();
                                }}
                            />
                        </div>
                    )}
                    {(mostrarDesDe || mostrarFinsA) && (
                        <div className={styles.contentInputs}>
                            <div className={styles.contentCalendaris}>
                                {mostrarDesDe && (
                                    <div className={styles.columnaCerca}>
                                        <label className={styles.label} htmlFor='cercador-fromDate'>
                                            Des de:
                                        </label>
                                        <div className={styles.inputCalendarWrapper}>
                                            <input
                                                ref={fromDateRef}
                                                type='date'
                                                data-testid='cercador-fromDate'
                                                id='cercador-fromDate'
                                                name='fromDate'
                                                placeholder='dd/mm/aaaa'
                                                value={formatDate(searchValueFrom)}
                                                aria-label='Cercador'
                                                className={styles.inputCalendar}
                                                onChange={onChangeCercadorValue}
                                                onKeyDown={({ key }) => {
                                                    if (key === 'Enter') submitSearch();
                                                }}
                                            />

                                            <span
                                                className={styles.calendarIcon}
                                                role='button'
                                                tabIndex={0}
                                                aria-label='Obrir calendari'
                                                onClick={() => handleIconClick(fromDateRef)}
                                                onKeyDown={(e) => handleIconKeyDown(e, fromDateRef)}
                                            />
                                        </div>
                                    </div>
                                )}
                                {mostrarFinsA && (
                                    <div className={styles.columnaCerca}>
                                        <label className={styles.label} htmlFor='cercador-toDate'>
                                            Fins a:
                                        </label>
                                        <div className={styles.inputCalendarWrapper}>
                                            <input
                                                ref={endDateRef}
                                                type='date'
                                                data-testid='cercador-toDate'
                                                id='cercador-toDate'
                                                name='toDate'
                                                placeholder='dd/mm/aaaa'
                                                value={formatDate(searchValueFrom)}
                                                aria-label='Cercador'
                                                className={styles.inputCalendar}
                                                onChange={onChangeCercadorValue}
                                                onKeyDown={({ key }) => {
                                                    if (key === 'Enter') submitSearch();
                                                }}
                                            />

                                            <span
                                                className={styles.calendarIcon}
                                                role='button'
                                                tabIndex={0}
                                                aria-label='Obrir calendari'
                                                onClick={() => handleIconClick(endDateRef)}
                                                onKeyDown={(e) => handleIconKeyDown(e, endDateRef)}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <div className={styles.contentBotoCerca}>
                        <Boto
                            text='Cerca'
                            estil='ple3cat100'
                            onClick={submitSearch}
                            tag='button'
                            type='submit'
                            dataTestId='cercador-submitCercador'
                            name='submitCercador'
                        />
                    </div>
                </div>
                {(filtresProfile || mostrarFiltrarPerData) && (
                    <div className={styles.contentFiltres}>
                        <FiltresProfile
                            filtres={filtresProfile}
                            actiu={props.routerQuery.profile}
                            onChange={(item) => {
                                searchParams.current.searchProfile = item.profile;
                                updateAndSubmit('urlCerca', item.urlCerca);
                            }}
                        />
                        <FiltresPerData
                            mostrarFiltrarPerData={mostrarFiltrarPerData}
                            onChange={(value) => {
                                updateAndSubmit('textDate', value);
                            }}
                        />
                    </div>
                )}
            </form>
        </TagSeo>
    );
};

export default CercadorFiltres;
